import React, { Component } from 'react';
import RunConnectivityTest from "../../webrtc-validator/conntest";
import TestCase from "./test_case";
import Call from "../../webrtc-validator/call";

export default class CallTest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      goNextState: false,
      cameraResolutionTest: null,
      testNumber: 1,
    };
    this.onTestFinished = this.onTestFinished.bind(this);
  }

  componentDidMount() {
    if (this.props.turnConfig !== undefined && this.state.cameraResolutionTest === null) {
      this.setState({ cameraResolutionTest: new RunConnectivityTest(Call.isRelay, this.props.turnConfig) });
    }
  }

  onTestFinished(testState) {
    if (this.state.testNumber === 3) {
      this.setState({ goNextState: testState });
    } else {
      if (this.state.testNumber === 1) {
        this.setState({ testNumber: 2, cameraResolutionTest: new RunConnectivityTest(Call.isReflexive, this.props.turnConfig) });
      } else {
        this.setState({ testNumber: 3, cameraResolutionTest: new RunConnectivityTest(Call.isHost, this.props.turnConfig) });
      }
    }
  }

  render() {
    return (
        <div>
          <h3 className={"text-center"}>Prueba de conexi&oacute;n</h3>
          <h4 className='text-center'>Paso {this.props.currentStep} de {this.props.totalSteps}</h4>
          <p>
            La siguiente prueba consiste en verificar si su conexión a internet y su navegador permiten realizar una
            conexión mediante video-conferencia con otros usuarios. Para esto, se utiliza una tecnología denominada <a href="https://webrtc.org/">WebRTC</a>. La prueba verificará si su computador está habilitado para
            utilizar dicha tecnología.
          </p>
          <p>
            Para comenzar presionar el botón "Ejecutar Test".
          </p>

          <TestCase runnable={this.state.cameraResolutionTest} onFinish={this.onTestFinished} multiple={true} />

          <TestCase runnable={this.state.cameraResolutionTest} onFinish={this.onTestFinished} multiple={true} automaticRun={this.state.testNumber === 2} />

          <TestCase runnable={this.state.cameraResolutionTest} onFinish={this.onTestFinished} multiple={true} automaticRun={this.state.testNumber === 3} last={true} />

          <button className='btn btn-primary btn-block' disabled={!this.state.goNextState} onClick={this.props.nextStep}>
              Siguiente
          </button>
        </div>
    );
  }
}
